import script from "./SolutionDemoCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionDemoCanvas.vue?vue&type=script&setup=true&lang=js"

import "./SolutionDemoCanvas.vue?vue&type=style&index=0&id=d24a19fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d24a19fe"]])

export default __exports__